import React, {useState} from 'react';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Typography from '@material-ui/core/Typography';
import {Box} from '@material-ui/core';
import PropTypes from "prop-types";
import {bbGetCampaignSimpleStatus, bbGetVectorSimpleStatus} from "../../../../util/bbHelpers";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    button: {
        marginRight: theme.spacing(2),
    },
    completed: {
        display: 'inline-block',
    },
    instructions: {
        fontSize: "smaller",
        marginBottom: theme.spacing(1),
        fontStyle: 'italic',
    },
}));

function getSteps() {
    return ['Identify', 'Recon', 'Attack', "Breach"];
}

function getCampaignSteps() {
    return ['Plan', 'Approve', 'Execute', "Complete"];
}

function stepTipDescriptions() {
    return {
        'Identify' : "Recognition that the indicated target might be susceptible to a BreachBits attack capability.",
        'Recon' : "Gathering more information about the target, e.g. to determine if the indicated attack capability will be effective.",
        'Attack' : "Preparing, conducting, and analyzing the results of attack actions; launching the capability against the target.",
        "Breach" : "One or more attacks have been successful, and analyzing the results."
    }
}

// function getStepContent(step) {
//     switch (step) {
//         case 0:
//             return 'Step 1: Select campaign settings...';
//         case 1:
//             return 'Step 2: What is an ad group anyways?';
//         case 2:
//             return 'Step 3: This is the bit I really care about!';
//         default:
//             return 'Unknown step';
//     }
// }

const VectorStepper = (props) => {

    const classes = useStyles();
    const {description, currentStatus, isCampaign = false, completeSteps = {0: true, 1: true, 2: false, 3: false}} = props;

    //translate the data into one of the 4 simple status codes
    const getActiveStepFromStatus = (status) => {

        return isCampaign ? bbGetCampaignSimpleStatus(status) : bbGetVectorSimpleStatus(status);
        // if (newActiveStep) {
        //     setActiveStep(newActiveStep);
        // }

    };

    //to show a check mark next to the things that were done, look deeper at the status.
    const getCompleteStepsFromStatus = (status) => {
        if (isCampaign) {
            switch(status) {
                case 0:
                    return {0: true, 1: false, 2: false, 3: false}
                case 1: //approved for attacks
                    return {0: true, 1: true, 2: false, 3: false}
                case 2:
                    return {0: true, 1: true, 2: false, 3: false}
                case 3:
                    return {0: true, 1: true, 2: true, 3: true}
                default:
                    return {0: false, 1: false, 2: false, 3: false}

            }
        } else {
            switch(status) {
                case 0:
                    return {0: true, 1: false, 2: false, 3: false}
                case 1: //approved for attacks
                case 2:
                case 3:
                    return {0: true, 1: true, 2: false, 3: false}
                case 4: //viable and attacks are ongoing
                case 8: //error during attack...
                case 9:// attacks denied by BB staff.  never left recon???
                    return {0: true, 1: true, 2: false, 3: false}
                case 6: //out of shlitz, no breach
                case 7: //attacks stopped before breach
                    return {0: true, 1: true, 2: true, 3: false}
                case 5: //got a breach
                    return {0: true, 1: true, 2: true, 3: true}
                default:
                    return {0: false, 1: false, 2: false, 3: false}

            }
        }

    };

    const [activeStep, setActiveStep] = useState(getActiveStepFromStatus(currentStatus));
    const [completed, setCompleted] = useState(getCompleteStepsFromStatus(currentStatus));
    const steps = isCampaign ? getCampaignSteps() : getSteps();
    // const stepToolTipDescriptions = stepTipDescriptions();

    const totalSteps = () => {
        return steps.length;
    };

    const completedSteps = () => {
        return Object.keys(completed).length;
    };

    const isLastStep = () => {
        return activeStep === totalSteps() - 1;
    };

    const allStepsCompleted = () => {
        return completedSteps() === totalSteps();
    };

    const handleNext = () => {
        const newActiveStep =
            isLastStep() && !allStepsCompleted()
                ? // It's the last step, but not all steps have been completed,
                  // find the first step that has been completed
                steps.findIndex((step, i) => !(i in completed))
                : activeStep + 1;
        setActiveStep(newActiveStep);
    };

    // const handleBack = () => {
    //     setActiveStep(prevActiveStep => prevActiveStep - 1);
    // };

    const handleStep = step => () => {
        //TODO: this is for admins to set the next step.
        // setActiveStep(step);
    };

    // const handleComplete = () => {
    //     const newCompleted = completed;
    //     newCompleted[activeStep] = true;
    //     setCompleted(newCompleted);
    //     handleNext();
    // };

    // const handleReset = () => {
    //     setActiveStep(0);
    //     setCompleted({});
    // };

    return (
        <Box className={classes.root}>
            <Stepper nonLinear activeStep={activeStep}>
                {steps.map((label, index) => (
                    <Step key={label}>
                        {/*TODO: remove the disabled FLAG below to enable clicking to set the step for admins.*/}
                        <StepButton disabled onClick={handleStep(index)} completed={completed[index]}>
                            {label}
                        </StepButton>
                    </Step>
                ))}
            </Stepper>
            <Box>
                <Box>
                    <Typography className={classes.instructions}>{description}</Typography>
                </Box>

                {/*{allStepsCompleted() ? (*/}
                {/*    <Box>*/}
                {/*        <Typography className={classes.instructions}>All steps completed - you&apos;re finished</Typography>*/}
                {/*        <Button onClick={handleReset}>Reset</Button>*/}
                {/*    </Box>*/}
                {/*) : (*/}
                {/*    <Box>*/}
                {/*        /!*<Typography className={classes.instructions}>{getStepContent(activeStep)}</Typography>*!/*/}
                {/*        <Box>*/}
                {/*            <Button disabled={activeStep === 0} onClick={handleBack} className={classes.button}>*/}
                {/*                Back*/}
                {/*            </Button>*/}
                {/*            <Button variant="contained" color="primary" onClick={handleNext} className={classes.button}>*/}
                {/*                Next*/}
                {/*            </Button>*/}
                {/*            {activeStep !== steps.length &&*/}
                {/*            (completed[activeStep] ? (*/}
                {/*                <Typography variant="caption" className={classes.completed}>*/}
                {/*                    Step {activeStep + 1} already completed*/}
                {/*                </Typography>*/}
                {/*            ) : (*/}
                {/*                <Button variant="contained" color="primary" onClick={handleComplete}>*/}
                {/*                    {completedSteps() === totalSteps() - 1 ? 'Finish' : 'Complete Step'}*/}
                {/*                </Button>*/}
                {/*            ))}*/}
                {/*        </Box>*/}
                {/*    </Box>*/}
                {/*)}*/}
            </Box>
        </Box>
    );
}

VectorStepper.propTypes = {
    description: PropTypes.string.isRequired,
    currentStatus: PropTypes.number.isRequired,
    completeSteps: PropTypes.object,
};

export default withStyles(null, {withTheme: true})(VectorStepper);